import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { FundingType, fundingTypesToHuman, PartnerTrade, Trade } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';


export default /*#__PURE__*/_defineComponent({
  __name: 'FundingTypeCell',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: Trade | PartnerTrade;
};



const isBoth = computed(() => props.trade.initialMarginFundingType === FundingType.COLLATERAL_AND_CREDIT);

const fundingType = computed(() => fundingTypesToHuman[props.trade.initialMarginFundingType ?? FundingType.UNDEFINED]);

return { __sfc: true,props, isBoth, fundingType, FundingType, fundingTypesToHuman, formatCurrencyValue }
}

})